export function renderOverviewSheet(container, { isOpen, notes, onClose, onSelectNote }) {
  if (!isOpen) {
    container.innerHTML = '';
    return;
  }

  container.innerHTML = `
    <div class="sheet-backdrop open" id="overview-backdrop"></div>
    <div class="sheet-modal open" id="overview-modal">
      <div class="sheet-handle-bar"></div>
      <div class="sheet-header">
        <div class="sheet-top-row">
          <span class="sheet-title">All Notes (${notes.length})</span>
          <button class="icon-btn" id="btn-close-overview">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="search-box">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input type="text" class="search-input" id="overview-search-input" placeholder="Search notes or #tags...">
        </div>
      </div>

      <div class="masonry-grid" id="overview-notes-masonry">
        ${renderNotesList(notes)}
      </div>
    </div>
  `;

  const backdrop = container.querySelector('#overview-backdrop');
  if (backdrop) backdrop.onclick = onClose;

  const closeBtn = container.querySelector('#btn-close-overview');
  if (closeBtn) closeBtn.onclick = onClose;

  const searchInput = container.querySelector('#overview-search-input');
  if (searchInput) {
    searchInput.oninput = (e) => {
      const q = e.target.value.toLowerCase().trim();
      const filtered = notes.filter(n => (n.content || '').toLowerCase().includes(q));
      const masonryEl = container.querySelector('#overview-notes-masonry');
      if (masonryEl) masonryEl.innerHTML = renderNotesList(filtered);
      bindCardClicks(container, onSelectNote, onClose);
    };
  }

  bindCardClicks(container, onSelectNote, onClose);
}

function renderNotesList(notes) {
  if (notes.length === 0) {
    return `<div style="grid-column: span 2; text-align: center; color: var(--ink-muted); padding: 48px 0;">No notes found</div>`;
  }

  // Pinned notes first
  const sorted = [...notes].sort((a, b) => (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0));

  return sorted.map(n => {
    const lines = (n.content || '').split('\n').filter(l => l.trim().length > 0);
    const title = lines[0] || 'Untitled Note';
    const preview = lines.slice(1).join(' ') || lines[0] || '';
    const dateStr = new Date(n.updatedAt || Date.now()).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

    return `
      <div class="note-card" data-note-id="${n.id}">
        <div class="note-card-title">${escapeHtml(title)}</div>
        <div class="note-card-preview">${escapeHtml(preview)}</div>
        <div class="note-card-footer">
          <span>${dateStr}</span>
          <div style="display: flex; gap: 4px;">
            ${n.reminderAt ? '🔔' : ''}
            ${n.isPinned ? '📌' : ''}
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function bindCardClicks(container, onSelectNote, onClose) {
  container.querySelectorAll('.note-card').forEach(card => {
    card.onclick = () => {
      if (navigator.vibrate) navigator.vibrate(10);
      const noteId = card.getAttribute('data-note-id');
      if (onSelectNote && noteId) {
        onSelectNote(noteId);
        onClose();
      }
    };
  });
}

function escapeHtml(str) {
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
